import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { useResendVerificationEmail } from "../../../hooks/useResendVerificationEmail";
import {
  RESEND_VERIFICATION_EMAIL_FAILED,
  RESEND_VERIFICATION_EMAIL_SUCCEEDED,
} from "../../../constants";

type TErrors = {
  resendVerificationEmailFailed: string | null;
};

const ERRORS_INITIAL_STATE: TErrors = {
  resendVerificationEmailFailed: null,
};

export const useSignUpPageFacade = () => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState<TErrors>(ERRORS_INITIAL_STATE);

  const navigate = useNavigate();

  const { resend: resendEmail, isLoading: resendingEmail } =
    useResendVerificationEmail({
      onSuccess: () => {
        setErrors((prev) => ({
          ...prev,
          resendVerificationEmailFailed: null,
        }));
        enqueueSnackbar(RESEND_VERIFICATION_EMAIL_SUCCEEDED, {
          variant: "success",
        });
      },
      onError: () => {
        setErrors((prev) => ({
          ...prev,
          resendVerificationEmailFailed: RESEND_VERIFICATION_EMAIL_FAILED,
        }));
      },
    });

  const handleSignUpSuccess = (email: string) => {
    setEmail(email);
  };

  const navigateToLogin = () => {
    navigate("/login");
  };

  return {
    email,
    errors,
    resendingEmail,
    resendEmail,
    handleSignUpSuccess,
    navigateToLogin,
  };
};